class Company {
  constructor (data = {}) {
    const {
      name,
      defaultCompany,
      email,
      phone,
      address,
      contactName,
      companyAdmins,
      companyLogo
    } = data

    this.name = name
    this.defaultCompany = defaultCompany
    this.email = email
    this.phone = phone
    this.address = address
    this.contactName = contactName
    this.companyAdmins = companyAdmins
    this.companyLogo = companyLogo
  }
}

Object.defineProperty(Company, 'initialData', {
  value: {
    name: '',
    email: '',
    phone: '',
    address: {
      country: '',
      region: '',
      province: '',
      zip: '',
      address: ''
    },
    contactName: '',
    companyAdmins: [],
    defaultCompany: {
      label: 'FALSE',
      value: false
    },
    companyLogo: ''
  },
  writable: false
})

export default Company
